



























































































































































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import { Constants } from "@/api-constants";
import { API } from "aws-amplify";
import { getModule } from "vuex-module-decorators";
import DecisionModule from "@/store/decision/Decision";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import viewpoint from "@/store/viewpoint/viewpoint";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import { Component, Watch } from "vue-property-decorator";
import AuthLogin from "@/components/auth/auth-login.vue";
import ViewpointSelector from "@/components/common/viewpoint-selector.vue";
import { ViewpointFactorResource } from "@/api/model/ViewpointFactorResource";
import Properties from "@/store/property/Properties";

let selectOptionsIntegers: any[] = [
  {text: '-', value: 0},
  {text: '1', value: 1},
  {text: '1+', value: -1},
  {text: '2', value: 2},
  {text: '2+', value: -2},
  {text: '3', value: 3},
  {text: '3+', value: -3},
  {text: '4', value: 4},
  {text: '4+', value: -4},
  {text: '5', value: 5},
  {text: '5+', value: -5},
  {text: '6', value: 6},
  {text: '6+', value: -6},
  {text: '7', value: 7},
  {text: '7+', value: -7},
  {text: '8', value: 8},
  {text: '8+', value: -8},
  {text: '9', value: 9},
  {text: '9+', value: -9},
];
let selectOptionsPrices: any[] = [
  {text: '-', value: 0},
  {text: '$50,000', value: 50000},
  {text: '$100,000', value: 100000},
  {text: '$150,000', value: 150000},
  {text: '$200,000', value: 200000},
  {text: '$250,000', value: 250000},
  {text: '$300,000', value: 300000},
  {text: '$350,000', value: 350000},
  {text: '$400,000', value: 400000},
  {text: '$450,000', value: 450000},
  {text: '$500,000', value: 500000},
  {text: '$550,000', value: 550000},
  {text: '$600,000', value: 600000},
  {text: '$650,000', value: 650000},
  {text: '$700,000', value: 700000},
  {text: '$750,000', value: 750000},
  {text: '$800,000', value: 800000},
  {text: '$850,000', value: 850000},
  {text: '$900,000', value: 900000},
  {text: '$950,000', value: 950000},
  {text: '$1,000,000', value: 1000000},
  {text: '$1,100,000', value: 1100000},
  {text: '$1,200,000', value: 1200000},
  {text: '$1,300,000', value: 1300000},
  {text: '$1,400,000', value: 1400000},
  {text: '$1,500,000', value: 1500000},
  {text: '$1,600,000', value: 1600000},
  {text: '$1,700,000', value: 1700000},
  {text: '$1,800,000', value: 1800000},
  {text: '$1,900,000', value: 1900000},
  {text: '$2,000,000', value: 2000000},
  {text: '$2,200,000', value: 2200000},
  {text: '$2,400,000', value: 2400000},
  {text: '$2,600,000', value: 2600000},
  {text: '$2,800,000', value: 2800000},
  {text: '$3,000,000', value: 3000000},
  {text: '$3,500,000', value: 3500000},
  {text: '$4,000,000', value: 4000000},
  {text: '$4,500,000', value: 4500000},
  {text: '$5,000,000', value: 5000000},
  {text: '$6,000,000', value: 6000000},
  {text: '$7,000,000', value: 7000000},
  {text: '$8,000,000', value: 8000000},
  {text: '$9,000,000', value: 9000000},
  {text: '$10,000,000', value: 10000000},
];

@Component({
  components: {}
})
export default class PropertySearch extends Vue {

  private propertyType = []
  private ownershipType = []
  private neighbourhood = []
  loadingSearch = false
  updatingFactors = false
  showAdvanced = false
  minPrices = selectOptionsPrices
  maxPrices = selectOptionsPrices
  beds = selectOptionsIntegers
  baths = selectOptionsIntegers
  parkingSpace = '' as any
  parkingSpaces = selectOptionsIntegers
  garageSpace = '' as any
  garagesSpaces = selectOptionsIntegers
  ownershipTypes = ['Residential', 'Condominium']
  propertyTypes = ['Single Family Residence', 'Townhouse', 'Apartment', 'Duplex', 'Triplex', 'Quadruplex']
  featureType = []
  featureTypes = [
    'Air Conditioning-Central',
    'Balcony',
    'Bar',
    'Barbecue-Built-In',
    'Ceiling 10 ft.',
    'Dance Floor',
    'Deck',
    'Dog Run-Fenced In',
    'Fire Pit',
    'Patio',
    'Pool-Indoor',
    'Vaulted Ceiling',
    'Wall Unit-Built-In',
    'Wood Windows',
    'No Smoking Home',
    'Programmable Thermostat',
    'Sprinkler System-Underground',
    'Workshop',
    'Open Beam',
    'Porch',
    'Handicap Access',
    'Handicap Interior Accessories',
    'Hot Water Tank - Energy Star',
    'Insulation-Upgraded',
    'Low Flow/Dual Flush Toilets',
    'No Animal Home',
    'Steam Room',
    'Sunroom',
    'Swirlpool Bath',
    'Vacuum System-Roughed-In',
    'Skylight',
    'Ceiling 9 ft.',
    'Pool-Outdoor',
    'Vinyl Windows',
    'Tankless Hot Water',
    'Sprinkler System-Fire',
    'Low Flow Faucets/Showerheads',
    'Sauna',
    'Security Window Bars',
    'Greenhouse',
    'Handyman Special',
    'None',
    'Asbestos',
    'Stone',
    'Vinyl',
    'Stucco',
    'Asphalt Shingles',
    'Brick',
    'Cedar',
    'Composite',
    'Fiber Cement Siding',
    'Concrete',
    'Metal',
    'Wood',
    'Log',
    'Wood Shingle',
    'Log Siding'
  ]
  neighbourhoodInput = null
  neighbourhoods = [
    'Abbeydale',
    'Acadia',
    'Albert Park/Radisson Heights',
    'Altadore',
    'Alyth/Bonnybrook',
    'Applewood Park',
    'Arbour Lake',
    'Aspen Woods',
    'Auburn Bay',
    'Aurora Business Park',
    'Banff Trail',
    'Bankview',
    'Bayview',
    'Beddington Heights',
    'Bel-Aire',
    'Beltline',
    'Bonavista Downs',
    'Bowness',
    'Braeside',
    'Brentwood',
    'Bridgeland/Riverside',
    'Bridlewood',
    'Britannia',
    'Burns Industrial',
    'Calgary International Airport',
    'Cambrian Heights',
    'Canyon Meadows',
    'Capitol Hill',
    'Carrington',
    'Castleridge',
    'Cedarbrae',
    'Chaparral',
    'Charleswood',
    'Chinatown',
    'Chinook Park',
    'Christie Park',
    'Citadel',
    'Cityscape',
    'Cliff Bungalow',
    'Coach Hill',
    'Collingwood',
    'Copperfield',
    'Coral Springs',
    'Cougar Ridge',
    'Country Hills',
    'Country Hills Village',
    'Coventry Hills',
    'Cranston',
    'Crescent Heights',
    'Crestmont',
    'Currie Barracks',
    'Dalhousie',
    'Deer Ridge',
    'Deer Run',
    'Deerfoot Business Centre',
    'Diamond Cove',
    'Discovery Ridge',
    'Douglasdale/Glen',
    'Dover',
    'Downtown',
    'Downtown East Village',
    'Downtown West End',
    'Eagle Ridge',
    'East Fairview Industrial',
    'East Shepard Industrial',
    'Eastfield',
    'Eau Claire',
    'Edgemont',
    'Elbow Park',
    'Elboya',
    'Erin Woods',
    'Erlton',
    'Evanston',
    'Evergreen',
    'Fairview',
    'Fairview Industrial',
    'Falconridge',
    'Foothills',
    'Forest Heights',
    'Forest Lawn',
    'Forest Lawn Industrial',
    'Franklin',
    'Garrison Green',
    'Garrison Woods',
    'Glamorgan',
    'Glenbrook',
    'Glendale',
    'Glendeer Business Park',
    'Golden Triangle',
    'Great Plains',
    'Greenview',
    'Greenview Industrial Park',
    'Greenwood/Greenbriar',
    'Hamptons',
    'Harvest Hills',
    'Hawkwood',
    'Haysboro',
    'Hidden Valley',
    'Highfield',
    'Highland Park',
    'Highwood',
    'Hillhurst',
    'Horizon',
    'Hounsfield Heights/Briar Hill',
    'Huntington Hills',
    'Inglewood',
    'Kelvin Grove',
    'Killarney/Glengarry',
    'Kincora',
    'Kingsland',
    'Lake Bonavista',
    'Lakeview',
    'Legacy',
    'Lincoln Park',
    'Livingston',
    'Lower Mount Royal',
    'Macewan Glen',
    'Mahogany',
    'Manchester',
    'Manchester Industrial',
    'Maple Ridge',
    'Marlborough',
    'Marlborough Park',
    'Martindale',
    'Mayfair',
    'Mayland',
    'Mayland Hieghts',
    'McCall',
    'McKenzie Lake',
    'McKenzie Towne',
    'Meadowland Park',
    'Meridian',
    'Midnapore',
    'Millrise',
    'Mission',
    'Monterey Park',
    'Montgomery',
    'Mount Pleasant',
    'New Brighton',
    'Nolan Hill',
    'North Airways',
    'North Glenmore Park',
    'North Haven',
    'North Haven Upper',
    'Oakridge',
    'Ogden',
    'Ogden Shops',
    'Palliser',
    'Panorama Hills',
    'Parkdale',
    'Parkhill',
    'Parkland',
    'Patterson',
    'Pegasus',
    'Penbrooke Meadows',
    'Pineridge',
    'Point McKay',
    'Pump Hill',
    'Queens Park Village',
    'Queensland',
    'Ramsay',
    'Ranchlands',
    'Red Carpet',
    'Redstone',
    'Renfrew',
    'Richmond',
    'Rideau Park',
    'Riverbend',
    'Rocky Ridge',
    'Rosedale',
    'Rosemont',
    'Rosscarrock',
    'Roxboro',
    'Royal Oak',
    'Royal Vista',
    'Rundle',
    'Rutland Park',
    'Saddle Ridge',
    'Saddle Ridge Industrial',
    'Sage Hill',
    'Sandstone Valley',
    'Scarboro',
    'Scarboro/Sunalta West',
    'Scenic Acres',
    'Seton',
    'Shaganappi',
    'Shawnee Slopes',
    'Shawnessy',
    'Shepard Industrial',
    'Sherwood',
    'Signal Hill',
    'Silver Springs',
    'Silverado',
    'Skyline East',
    'Skyline West',
    'Skyview Ranch',
    'Somerset',
    'South Airways',
    'South Calgary',
    'South Foothills',
    'Southview',
    'Southwood',
    'Springbank Hill',
    'Spruce Cliff',
    'St. Andrews Heights',
    'Starfield',
    'Stonegate Landing',
    'Stoney 1',
    'Stoney 2',
    'Stoney 3',
    'Stoney 4',
    'Strathcona Park',
    'Sunalta',
    'Sundance',
    'Sunnyside',
    'Sunridge',
    'Taradale',
    'Temple',
    'Thorncliffe',
    'Tuscany',
    'Tuxedo Park',
    'University District',
    'University Heights',
    'University of Calgary',
    'Upper Mount Royal',
    'Valley Ridge',
    'Valleyfield',
    'Varsity',
    'Vista Heights',
    'Walden',
    'West Hillhurst',
    'West Springs',
    'Westgate',
    'Westwinds',
    'Whitehorn',
    'Wildwood',
    'Willow Park',
    'Windsor Park',
    'Winston Heights/Mountainview',
    'Woodbine',
    'Woodlands'
  ]


  get viewpointFactors() {
    return getModule(ViewpointsModule).viewpointFactors
  }

  get factors() {
    return Object.values(getModule(DecisionModule).factors)
  }

  get minPrice() {
    let priceFactor = _.filter(this.factors, {'dataField': 'price'})[0];
    let viewpointPriceFactor = this.getViewpointFactor(priceFactor.id)
    return this.getMin(viewpointPriceFactor)
  }

  set minPrice(val: any) {
    let priceFactor = _.filter(this.factors, {'dataField': 'price'})[0];
    let viewpointPriceFactor = this.getViewpointFactor(priceFactor.id)
    this.setMin(viewpointPriceFactor, val)
  }

  get maxPrice() {
    let priceFactor = _.filter(this.factors, {'dataField': 'price'})[0];
    let viewpointPriceFactor = this.getViewpointFactor(priceFactor.id)
    return this.getMax(viewpointPriceFactor)
  }

  set maxPrice(val: any) {
    let priceFactor = _.filter(this.factors, {'dataField': 'price'})[0];
    let viewpointPriceFactor = this.getViewpointFactor(priceFactor.id)
    this.setMax(viewpointPriceFactor, val)
  }


  get minYearBuilt() {
    let yearBuiltFactor = _.filter(this.factors, {'dataField': 'yearBuilt'})[0];
    let viewpointYearBuilt = this.getViewpointFactor(yearBuiltFactor.id)
    return this.getMin(viewpointYearBuilt)
  }

  set minYearBuilt(val: any) {
    let yearBuiltFactor = _.filter(this.factors, {'dataField': 'yearBuilt'})[0];
    let viewpointYearBuilt = this.getViewpointFactor(yearBuiltFactor.id)
    this.setMin(viewpointYearBuilt, val)
  }

  get maxYearBuilt() {
    let yearBuiltFactor = _.filter(this.factors, {'dataField': 'yearBuilt'})[0];
    let viewpointYearBuilt = this.getViewpointFactor(yearBuiltFactor.id)
    return this.getMax(viewpointYearBuilt)
  }

  set maxYearBuilt(val: any) {
    let yearBuiltFactor = _.filter(this.factors, {'dataField': 'yearBuilt'})[0];
    let viewpointYearBuilt = this.getViewpointFactor(yearBuiltFactor.id)
    this.setMax(viewpointYearBuilt, val)
  }

  get minLotSize() {
    let factor = _.filter(this.factors, {'dataField': 'lotSize'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    return this.getMin(viewpointFactor) * 43560
  }

  set minLotSize(val: any) {
    let factor = _.filter(this.factors, {'dataField': 'lotSize'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    this.setMin(viewpointFactor, val / 43560)
  }

  get maxLotSize() {
    let factor = _.filter(this.factors, {'dataField': 'lotSize'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    return this.getMax(viewpointFactor) * 43560
  }

  set maxLotSize(val: any) {
    let factor = _.filter(this.factors, {'dataField': 'lotSize'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    this.setMax(viewpointFactor, val / 43560)
  }

  get minBuildingSize() {
    let factor = _.filter(this.factors, {'dataField': 'finishedArea'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    return this.getMin(viewpointFactor)
  }

  set minBuildingSize(val: any) {
    let factor = _.filter(this.factors, {'dataField': 'finishedArea'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    this.setMin(viewpointFactor, val)
  }

  get maxBuildingSize() {
    let factor = _.filter(this.factors, {'dataField': 'finishedArea'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    return this.getMax(viewpointFactor)
  }

  set maxBuildingSize(val: any) {
    let factor = _.filter(this.factors, {'dataField': 'finishedArea'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    this.setMax(viewpointFactor, val)
  }

  get bed() {
    let factor = _.filter(this.factors, {'dataField': 'bedrooms'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (viewpointFactor && viewpointFactor.constraint) {
      if (viewpointFactor.constraint.operator === 'EQ') {
        return viewpointFactor.constraint.values[0]
      }
      return viewpointFactor.constraint.values[0] * -1
    }
  }

  set bed(val: number | undefined) {
    let factor = _.filter(this.factors, {'dataField': 'bedrooms'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (val == null) {
      delete viewpointFactor.constraint
    } else {
      let operator = val < 0 ? 'GTE' : 'EQ';
      viewpointFactor.constraint = {
        operator: operator,
        values: [Math.abs(val)]
      }
    }
  }

  get bath() {
    let factor = _.filter(this.factors, {'dataField': 'bathrooms'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (viewpointFactor && viewpointFactor.constraint) {
      if (viewpointFactor.constraint.operator === 'EQ') {
        return viewpointFactor.constraint.values[0]
      }
      return viewpointFactor.constraint.values[0] * -1
    }
  }

  set bath(val: number | undefined) {
    let factor = _.filter(this.factors, {'dataField': 'bathrooms'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (val == null) {
      delete viewpointFactor.constraint
    } else {
      let operator = val < 0 ? 'GTE' : 'EQ';
      viewpointFactor.constraint = {
        operator: operator,
        values: [Math.abs(val)]
      }
    }
  }

  get searchText() {
    let factor = _.filter(this.factors, {'dataField': 'keyword'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (viewpointFactor && viewpointFactor.constraint) {
      if (viewpointFactor.constraint.operator === 'EQ') {
        return viewpointFactor.constraint.values[0]
      }
    }
    return ''
  }

  set searchText(val: string) {
    let factor = _.filter(this.factors, {'dataField': 'keyword'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (val == null) {
      delete viewpointFactor.constraint
    } else {
      viewpointFactor.constraint = {
        operator: 'EQ',
        values: [val]
      }
    }
  }

  get ownershipTypeFactor() {
    let factor = _.filter(this.factors, {'dataField': 'type'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (viewpointFactor && viewpointFactor.constraint) {
      this.ownershipType = viewpointFactor.constraint.values
    }
    return viewpointFactor
  }

  get propertyTypeFactor() {
    let factor = _.filter(this.factors, {'dataField': 'buildingType'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (viewpointFactor && viewpointFactor.constraint) {
      this.propertyType = viewpointFactor.constraint.values
    }
    return viewpointFactor
  }

  get neighbourhoodFactor() {
    let factor = _.filter(this.factors, {'dataField': 'neighborhood'})[0];
    let viewpointFactor = this.getViewpointFactor(factor.id)
    if (viewpointFactor && viewpointFactor.constraint) {
      this.neighbourhood = viewpointFactor.constraint.values
    }
    return viewpointFactor
  }

  private getViewpointFactor(factorId: string) {
    if (!this.viewpointFactors[factorId]) {
      this.viewpointFactors[factorId] = {
        viewpointId: getModule(ViewpointsModule).selectedViewpointId,
        id: factorId
      }
    }
    return this.viewpointFactors[factorId];
  }


  private getMin(viewpointFactor: any) {
    if (viewpointFactor && viewpointFactor.constraint) {
      if (['GTE', 'GTELTE'].includes(viewpointFactor.constraint.operator)) {
        return viewpointFactor.constraint.values[0]
      }
    }
    return ''
  }

  private getMax(viewpointFactor: any) {
    if (viewpointFactor && viewpointFactor.constraint) {
      if (viewpointFactor.constraint.operator === 'GTELTE') {
        return viewpointFactor.constraint.values[1]
      } else if (viewpointFactor.constraint.operator === 'LTE') {
        return viewpointFactor.constraint.values[0]
      }
    }
    return ''
  }

  private setMin(viewpointFactor: any, value: any) {
    if (viewpointFactor && viewpointFactor.constraint) {
      if (['GTE', 'GTELTE'].includes(viewpointFactor.constraint.operator)) {
        if (value && _.isNumber(value)) {
          viewpointFactor.constraint.values[0] = value;
        } else if (viewpointFactor.constraint.operator === 'GTE') {
          delete viewpointFactor.constraint
        } else {
          viewpointFactor.constraint.operator = 'LTE'
          viewpointFactor.constraint.values = [viewpointFactor.constraint.values[1]]
        }
      } else if (viewpointFactor.constraint.operator === 'LTE') {
        if (value && _.isNumber(value)) {
          viewpointFactor.constraint.operator = 'GTELTE'
          viewpointFactor.constraint.values = [value, viewpointFactor.constraint.values[0]]
        }
      }
    } else {
      viewpointFactor.constraint = {
        operator: "GTE",
        values: [value]
      }
    }
  }

  private setMax(viewpointFactor: any, value: any) {
    if (viewpointFactor && viewpointFactor.constraint) {
      if (viewpointFactor.constraint.operator === 'GTELTE') {
        if (value && _.isNumber(value)) {
          viewpointFactor.constraint.values[1] = value;
        } else {
          viewpointFactor.constraint.operator = 'GTE'
          viewpointFactor.constraint.values = [viewpointFactor.constraint.values[0]]
        }
      } else if (viewpointFactor.constraint.operator === 'LTE') {
        if (value && _.isNumber(value)) {
          viewpointFactor.constraint.values = [value]
        } else {
          delete viewpointFactor.constraint
        }
      }
    } else {
      viewpointFactor.constraint = {
        operator: "LTE",
        values: [value]
      }
    }
  }


  async updateFactors() {
    this.showAdvanced = false;
    this.updatingFactors = true;

    this.setCategoricalConstraint(this.ownershipTypeFactor, this.ownershipType)
    this.setCategoricalConstraint(this.propertyTypeFactor, this.propertyType)
    this.setCategoricalConstraint(this.neighbourhoodFactor, this.neighbourhood)

    await getModule(ViewpointsModule).putViewpointFactors(Object.values(this.viewpointFactors))

    this.updatingFactors = false;
  }

  private setCategoricalConstraint(factor: ViewpointFactorResource, values: any[]) {
    if (values == null || values.length === 0) {
      delete factor.constraint
    } else {
      factor.constraint = {
        operator: 'IN',
        values: values
      }
    }
  }


}

